<template>
  <div>
    <div class="con-vs-alert con-vs-alert-danger mb-4">
      <div class="vs-alert text-center" v-if="dispositivo.apkversion.indexOf('4.') === 0">{{ $t('TxtVip') }}</div>
      <div class="vs-alert text-center" v-else>{{ $t('TxtClientVip') }}.</div>
    </div>

    <div class="text-center">
      <!-- <a :href="`/planos/mobile/${dispositivo.uid}/1`" rel="noopener"> -->
      <!-- pt -->
      <a v-if="$i18n.locale === 'pt'" :href="`${urlSite}/checkout/payment?planId=12&d=${device}`" rel="noopener">
        <button name="button" class="vs-component vs-button vs-button-warning vs-button-relief mt-3 mr-2">
          <span class="vs-button-text vs-button--text"> <i class="fas fa-mobile"></i> {{ $t('SeePlans') }}</span>
          <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"></span>
        </button>
      </a>
      <!-- en -->
      <a v-else :href="`${urlSite}/checkout/payment?planId=2024&d=${device}`" rel="noopener">
        <button name="button" class="vs-component vs-button vs-button-warning vs-button-relief mt-3 mr-2">
          <span class="vs-button-text vs-button--text"> <i class="fas fa-mobile"></i> {{ $t('SeePlans') }}</span>
          <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"></span>
        </button>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appName: process.env.VUE_APP_NAME,
      urlSite: process.env.VUE_APP_URL_COMPRA,
      dispositivo: {},
      device: ''
    };
  },
  mounted() {
    this.dispositivo = JSON.parse(this.$localStorage.get('mobile'));
    this.device = btoa(this.dispositivo.device + (this.dispositivo.alias ? ' (' + this.dispositivo.alias + ')' : ''));
  }
};
</script>
